export { CreateRoomViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
